import React from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Grow,
  Paper,
  Typography,
} from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EastIcon from "@mui/icons-material/East";
import usePricing from "Hooks/usePricing";
import { useNavigation } from "Hooks/navigate";
import CustomButton from "Common/CustomButton";
import { ArrowBack } from "@mui/icons-material";

const LeftPaneData = {
  heading: "WELCOME TO TAS",
  subHeading: "Trusted Advisory Service",
  bulletPoints: [
    "TAS facilitates secure and private business-to-business relationships between members and peers, ultimately enhancing the service provided to private wealth clients and families.",
    "PRIVATE WEALTH FAMILY FIRMS can search and engage with PRIVATE WEALTH ADVISOR FIRMS WHICH ARE jurisdictionally licensed domain expert Advisors in areas such as wealth planning, investment, asset management, tax planning, financial planning, accounting, tax strategy, legal agreements, succession planning, life insurance, trust planning, estate planning, philanthropy planning, and family enterprise.",
  ],
};
const disablePricing = true; // Set to true to disable pricing page access

const AdvisorBUTTONS = [
  {
    label: "Sign In",
    icon: <LoginIcon sx={{ fontSize: 20 }} />,
    link: "/sign-in/advisor",
  },
  {
    label: "Register",
    icon: <AppRegistrationIcon sx={{ fontSize: 20 }} />,
    link: "/advisor-registration",
  },
  {
    label: "Pricing",
    icon: <AttachMoneyIcon sx={{ fontSize: 20 }} />,
    link: "/subscription/advisor",
    disabled: disablePricing,
  },
];
const ClientBUTTONS = [
  {
    label: "Sign In",
    icon: <LoginIcon sx={{ fontSize: 20 }} />,
    link: "/sign-in/client",
  },
  {
    label: "Register",
    icon: <AppRegistrationIcon sx={{ fontSize: 20 }} />,
    link: "/client-registration",
  },
  {
    label: "Pricing",
    icon: <AttachMoneyIcon sx={{ fontSize: 20 }} />,
    link: "/subscription/client",
    disabled: disablePricing,
  },
];

const TASWelcome = () => {
  const { goTo, goHome } = useNavigation();
  usePricing(); // This hook is called here so that static pricing data is fetched from DB and stored in hook.

  return (
    <Box
      sx={{
        background: "linear-gradient(to right, #041e42, #78a8e6)",
        minHeight: "100vh",
        color: "white",
        display: "flex",
        alignItems: "center",
        py: 8,
      }}
    >
      <Container>
        <Grid container spacing={4} alignItems="center">
          {/* LEFT SIDE */}
          <Grid item xs={12} md={7}>
            <Typography variant="h3" fontWeight="bold" gutterBottom>
              {LeftPaneData.heading}
            </Typography>
            <Grow in timeout={1000}>
              <div>
                <Typography variant="h5" gutterBottom>
                  {LeftPaneData.subHeading}
                </Typography>
                {LeftPaneData.bulletPoints.map((item, index) => (
                  <Typography key={index} variant="body1" sx={{ mb: 2, color: "#e0e0e0" }}>
                    <EastIcon sx={{ fontSize: 16, mr: 1, pt: 0.5 }} />
                    {item}
                  </Typography>
                ))}
                <CustomButton
                  startIcon={<ArrowBack fontSize="small" />}
                  onClick={() => goHome()}
                  sx={{ mt: 3 }}
                  size="small"
                  variant={"gradient"}
                >
                  Back</CustomButton>
              </div>
            </Grow>
          </Grid>

          {/* RIGHT SIDE */}
          <Grid item xs={12} md={5}>
            <Typography variant="h3" align="center" sx={{ mb: 3 }} onClick={() => goHome()}>
              <span style={{ cursor: "pointer", color: "#fff" }}>T</span>
              <span style={{ cursor: "pointer", color: "#fbb034" }}>A</span>
              <span style={{ cursor: "pointer", color: "#fff" }}>S</span>
            </Typography>
            <Typography align="center" sx={{ color: "#e0e0e0", mb: 2 }}>
              Select an option below to get started
            </Typography>
            <Grow in timeout={1000}>
              <Grid container spacing={2}>
                {/* Advisor Column */}
                <Grid item xs={6} sx={{ display: 'flex' }}>
                  <Paper elevation={4} sx={{ p: 3, borderRadius: 2, height: '100%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <Typography
                      variant="h6"
                      align="center"
                      fontWeight="bold"
                      sx={{ mb: 2 }}
                      color={"#404040"}
                    >
                      Private Wealth Advisor Firm
                    </Typography>
                    <Grid container direction="column" spacing={1}>
                      {AdvisorBUTTONS.map((button, index) => (
                        <Grid item key={index}>
                          <Button
                            fullWidth
                            variant="outlined"
                            startIcon={button.icon}
                            sx={{
                              justifyContent: "flex-start",
                              pl: 2.5,
                              py: 1.5,
                              textTransform: "none",
                              fontWeight: 500,
                              gap: 1.5,
                            }}
                            onClick={() => goTo(button.link)}
                            disabled={button.disabled}
                          >
                            {button.label}
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                </Grid>

                {/* Client Column */}
                <Grid item xs={6} sx={{ display: 'flex' }}>
                  <Paper elevation={4} sx={{ p: 3, borderRadius: 2, height: '100%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <Typography
                      variant="h6"
                      align="center"
                      fontWeight="bold"
                      sx={{ mb: 2 }}
                      color={"#404040"}
                    >
                      Private Wealth Family Firm
                    </Typography>
                    <Grid container direction="column" spacing={1}>
                      {ClientBUTTONS.map((button, index) => (
                        <Grid item key={index}>
                          <Button
                            fullWidth
                            variant="outlined"
                            startIcon={button.icon}
                            sx={{
                              justifyContent: "flex-start",
                              pl: 2.5,
                              py: 1.5,
                              textTransform: "none",
                              fontWeight: 500,
                              gap: 1.5,
                            }}
                            onClick={() => goTo(button.link)}
                            disabled={button.disabled}
                          >
                            {button.label}
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Grow>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default TASWelcome;
